import axios from "axios";
import * as echarts from "echarts";
import { useCallback, useEffect, useState } from "react";
import { ChinaGeoJSONLink } from "@/constant/links";

interface UseMapModelStateType {
  // 是否已经加载了地图数据
  isLoadedGeoJSON: boolean;
}
const initialState: UseMapModelStateType = {
  isLoadedGeoJSON: false,
};
export default function useMapModel(): UseMapModelStateType {
  const [state, setState] = useState(initialState);

  const handleLoadMapData = useCallback(async () => {
    try {
      const res = await axios.get<string>(ChinaGeoJSONLink);
      setState((prevState) => ({
        ...prevState,
        isLoadedGeoJSON: true,
      }));
      // 注册地图数据
      echarts.registerMap("china", res.data);
    } catch (error) {
      console.error("Failed to load and register the GeoJSON map data", error);
    }
  }, []);

  useEffect(() => {
    handleLoadMapData();
  }, []);

  return {
    ...state,
  };
}
